export default __webpack_public_path__ + "static/media/user.1d3b799d.svg";